import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "./common/Navigation";
import ContactUs from "./common/ContactUs";
import AboutUs from "./common/AboutUs";
import FedSupplier from "./common/FedSupplier";
import Portfolio from "./common/Portfolio";
import Footer from "./common/Footer";
import Services from "./common/Services";
import Home from "./common/Home";

// Paths that deep-link to a section (e.g. /fedsupplier is printed on the
// official BizMak capability statement).
const pathToSection = {
  "/fedsupplier": "fedsupplier",
  "/government": "fedsupplier",
  "/contact": "contact",
  "/services": "service",
};

export default function PublicSite() {
  const { pathname } = useLocation();

  useEffect(() => {
    const sectionId = pathToSection[pathname.toLowerCase()];
    if (sectionId) {
      // Wait a tick so the sections have rendered before scrolling.
      requestAnimationFrame(() => {
        document
          .getElementById(sectionId)
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }, [pathname]);

  return (
    <>
      <Navigation />
      <Home />
      <Services />
      <Portfolio />
      <FedSupplier />
      <AboutUs />
      <ContactUs />
      <Footer />
    </>
  );
}
